import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-760e155c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dutycard" }
const _hoisted_2 = { class: "dutycard-upper" }
const _hoisted_3 = { class: "dutycard-upper-left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "personinfo" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "profession" }
const _hoisted_8 = { class: "dutycard-upper-right" }
const _hoisted_9 = { class: "duty-num" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("天 ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profession" }, "本月出勤", -1))
const _hoisted_12 = { class: "dutycard-under" }
const _hoisted_13 = { style: {"margin-bottom":"10px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag" }, "进入时间", -1))
const _hoisted_15 = { class: "time" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag" }, "离开时间", -1))
const _hoisted_17 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "avtor",
          src: _ctx.personInfo.photoUrl
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.personInfo.userName), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.personInfo.stationName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_ctx.personInfo.days), 1),
          _hoisted_10
        ]),
        _hoisted_11
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.personInfo.inDate ? _ctx.personInfo.inDate.substr(11, 8) : "未签到"), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_16,
        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.personInfo.outDate ? _ctx.personInfo.outDate.substr(11, 8) : "未签到"), 1)
      ])
    ])
  ]))
}